import { connect } from 'react-redux';
import * as PaymentAction from './PaymentAction';

const AutoPaymentInjector =
    (stateToProps = null, dispatchToProps = null) =>
    (WrapperComponent) => {
        const mapDispatchToProps = (dispatch, ownProps) => {
            let props = {};
            if (dispatchToProps !== null) {
                props = dispatchToProps(dispatch, ownProps);
            }
            return {
                completedAction: () => {
                    dispatch(PaymentAction.completedAction());
                },
                initProduct: () => {
                    dispatch(PaymentAction.initProduct());
                },
                initApplyInfo: () => {
                    dispatch(PaymentAction.initApplyInfo());
                },
                initPayment: (platform, client_origin, pg_code, notify_email, mobile_os_type = undefined) => {
                    dispatch(PaymentAction.initPayment(platform, client_origin, pg_code, notify_email, mobile_os_type));
                },
                setPaymentMode: (mode) => {
                    dispatch(PaymentAction.setPaymentMode(mode));
                },
                clearPaymentMode: () => {
                    dispatch(PaymentAction.clearPaymentMode());
                },
                setNotifyEmail: (notifyEmail) => {
                    dispatch(PaymentAction.setNotifyEmail(notifyEmail));
                },
                setUserInfo: (userInfo) => {
                    dispatch(PaymentAction.setUserInfo(userInfo));
                },
                setCheckList: (checkList) => {
                    dispatch(PaymentAction.setCheckList(checkList));
                },
                processPayment: (isProcssPayment) => {
                    dispatch(PaymentAction.processPayment(isProcssPayment));
                },
                setPayType: (payType) => {
                    dispatch(PaymentAction.setPayType(payType));
                },
                getSelectedStudentInfo: (studentInfo) => {
                    dispatch(PaymentAction.getSelectedStudentInfo(studentInfo));
                },
                setAutoPayment: (isAutoPayment, buyer_ssn, installment = '00', check_ssn = 'N', paynow_only = 'N') => {
                    dispatch(
                        PaymentAction.setAutoPayment(
                            isAutoPayment,
                            buyer_ssn,
                            installment,
                            check_ssn,
                            (paynow_only = 'N')
                        )
                    );
                },
                addAutoPayment: (params, request_channel, delivery_message, levels, register_code, content_info) => {
                    dispatch(
                        PaymentAction.addAutoPayment(
                            params,
                            request_channel,
                            delivery_message,
                            levels,
                            register_code,
                            content_info
                        )
                    );
                },
                addNaverPayAutoPayment: (
                    params,
                    request_channel,
                    delivery_message,
                    levels,
                    register_code,
                    content_info
                ) => {
                    dispatch(
                        PaymentAction.addNaverPayAutoPayment(
                            params,
                            request_channel,
                            delivery_message,
                            levels,
                            register_code,
                            content_info
                        )
                    );
                },
                confirmAutoPayment: (payId, params) => {
                    dispatch(PaymentAction.confirmAutoPayment(payId, params));
                },
                confirmNaverPayAutoPayment: (contractId, params) => {
                    dispatch(PaymentAction.confirmNaverPayAutoPayment(contractId, params));
                },
                setApplyType: (applyType = '') => {
                    dispatch(PaymentAction.setApplyType(applyType));
                },
                modifyDeliveryMessage: (issueId, message) => {
                    dispatch(PaymentAction.modifyDeliveryMessage(issueId, message));
                },

                //상품 선택
                setProduct: (
                    selectedProduct,
                    amount,
                    monthly,
                    contract_years,
                    contract_end_date,
                    selectedProductItem
                ) => {
                    dispatch(
                        PaymentAction.setProduct(
                            selectedProduct,
                            amount,
                            monthly,
                            contract_years,
                            contract_end_date,
                            selectedProductItem
                        )
                    );
                },
                getProductList: () => {
                    dispatch(PaymentAction.getProductList());
                },
                getStudentPaymentContractListInfo: (studentList) => {
                    dispatch(PaymentAction.getStudentPaymentContractListInfo(studentList));
                },
                getAutoPaymentContractList: (studentList) => {
                    dispatch(PaymentAction.getAutoPaymentContractList(studentList));
                },
                getShopProductList: (category) => {
                    dispatch(PaymentAction.getShopProductList(category));
                },

                //쿠폰
                initCoupon: () => {
                    dispatch(PaymentAction.initCoupon());
                },
                getCouponList: (parentId, productId) => {
                    dispatch(PaymentAction.getCouponList(parentId, productId));
                },
                setCoupon: (coupons, discountAmount) => {
                    dispatch(PaymentAction.setCoupon(coupons, discountAmount));
                },
                addCoupon: (coupon = '') => {
                    dispatch(PaymentAction.addCoupon(coupon));
                },
                ...props,
            };
        };
        const mapStateToProps = (state, ownProps) => {
            let props = {};
            if (stateToProps !== null) {
                props = stateToProps(state, ownProps);
            }
            return {
                // 학생 & 부모 정보
                user_info: state.PaymentReducer.user_info,

                // 결제 기본 정보 //
                platform: state.PaymentReducer.platform,
                client_origin: state.PaymentReducer.client_origin,
                pg_code: state.PaymentReducer.pg_code,
                notify_email: state.PaymentReducer.notify_email,
                mobile_os_type: state.PaymentReducer.mobile_os_type,
                model_type: state.PaymentReducer.model_type,
                payType: state.PaymentReducer.payType,
                isAutoPayment: state.PaymentReducer.isAutoPayment,
                installment: state.PaymentReducer.installment,
                buyer_ssn: state.PaymentReducer.buyer_ssn,
                check_ssn: state.PaymentReducer.check_ssn,
                paynow_only: state.PaymentReducer.paynow_only,

                // 진행중의 상태 //
                addInfo: state.PaymentReducer.addInfo,
                confirmInfo: state.PaymentReducer.confirmInfo,
                isProcssPayment: state.PaymentReducer.isProcssPayment,

                //아이선택
                selectedStudentInfo: state.PaymentReducer.selectedStudentInfo,
                checkList: state.PaymentReducer.checkList,
                applyType: state.PaymentReducer.applyType,
                studentPaymentContractListInfo: state.PaymentReducer.studentPaymentContractListInfo,

                //상품 선택
                amount: state.PaymentReducer.amount,
                coupons: state.PaymentReducer.coupons,
                productInfo: state.PaymentReducer.productInfo,
                contract_years: state.PaymentReducer.contract_years,
                contract_end_date: state.PaymentReducer.contract_end_date,
                selectedProduct: state.PaymentReducer.selectedProduct,
                monthly: state.PaymentReducer.monthly,
                isApply: state.PaymentReducer.action === 'successapply',
                isModifyMessage: state.PaymentReducer.action === 'modifymassage',
                productList: state.PaymentReducer.productList,
                shopProductList: state.PaymentReducer.shopProductList,
                paymentMode: state.PaymentReducer.paymentMode,
                selectedProductItem: state.PaymentReducer.selectedProductItem,

                // 쿠폰
                couponList: state.PaymentReducer.couponList,
                selectCoupon: state.PaymentReducer.selectCoupon,
                discountAmount: state.PaymentReducer.discountAmount,
                isAddCoupon: state.PaymentReducer.action === 'successaddcoupon',
                isFailAddCoupon: state.PaymentReducer.action === 'failaddcoupon',

                // 결제 진행단계 상태 //
                isProcessAutoPayment: state.PaymentReducer.isProcessAutoPayment,
                isAutoPaymentError: state.PaymentReducer.isAutoPaymentError,

                history: ownProps.history,
                ...props,
            };
        };

        return connect(mapStateToProps, mapDispatchToProps)(WrapperComponent);
    };

export default AutoPaymentInjector;
